import { useAuth0 } from "@auth0/auth0-react";
import { NavDropdown } from "react-bootstrap";
import { Link } from "react-router";
import isAdmin from "../Auth/isAdmin";

export default function AdminNavLink() {
  const { user } = useAuth0();
  if (isAdmin(user)) {
    return (
      <NavDropdown title="Admin" id="basic-nav-dropdown">
        <NavDropdown.Item to="/authenticated" as={Link}>
          Authenticated
        </NavDropdown.Item>
        <NavDropdown.Item to="/authenticated" as={Link}>
          No results
        </NavDropdown.Item>
        <NavDropdown.Item to="/authenticated" as={Link}>
          Users
        </NavDropdown.Item>
      </NavDropdown>
    );
  }
  return null;
}
